/** postMessage type from `/invest/signing-complete` when loaded inside a signing iframe */
export const SIGNING_COMPLETE_MESSAGE_TYPE = 'SIGNNOW_SIGNING_COMPLETE' as const

/** Legacy type from earlier FE builds — still accepted by parent listeners */
export const LEGACY_SIGNING_COMPLETE_MESSAGE_TYPE = 'greenback:signing-complete' as const

export type SigningCompleteMessage = {
  type: typeof SIGNING_COMPLETE_MESSAGE_TYPE | typeof LEGACY_SIGNING_COMPLETE_MESSAGE_TYPE
}

export const isSigningCompleteMessage = (data: unknown): data is SigningCompleteMessage =>
  typeof data === 'object' &&
  data !== null &&
  'type' in data &&
  ((data as { type: unknown }).type === SIGNING_COMPLETE_MESSAGE_TYPE ||
    (data as { type: unknown }).type === LEGACY_SIGNING_COMPLETE_MESSAGE_TYPE)

export const postSigningCompleteToParent = (): boolean => {
  if (typeof window === 'undefined' || window.parent === window) return false
  window.parent.postMessage(
    { type: SIGNING_COMPLETE_MESSAGE_TYPE } satisfies SigningCompleteMessage,
    window.location.origin,
  )
  return true
}
